module.exports = __webpack_public_path__ + "static/media/karthik_karuppaiah_01.e9086ff0.png";